/**
 * @ngdoc object
 * @name templates.controller:TemplatesCtrl
 *
 * @description
 *
 */
import FestzeltOSSeatPlanDrawing from '../scripts/drawing.seatplans.festzelt-os';
import '../views/elements/treeElement.tpl.html';

class SeatplanElementsController {
    constructor($state, SweetAlert, model, Env, $http, $element, $scope, $uibModal, locale, NavService, growl) {
        this.state = $state;
        this.sweetAlert = SweetAlert;
        this.model = model;
        this.api = $http;
        this.element = $element;
        this.scope = $scope;
        this.modal = $uibModal;
        this.locale = locale;
        this.navService = NavService;
        this.growl = growl;

        this.canvasElement = angular.element(this.element.find('canvas')[0]);
        this.builder = null;
        this.drawInfo = null;
        this.drawing = null;

        this._initWatchers();
        this._initDomEvents();
        this._loadBuilder();
        this._updateNavService();
    }

    _initWatchers() {
        this.scope.$watch(angular.bind(this, function () {
            return this.builder;
        }), (newVal) => {
            if (newVal) {
                this.refreshPreview();
            }
        });
    }

    _loadBuilder() {
        this.api.get('seatplans/groups/' + this.model.id + '/builder').then((response) => {
            this.builder = response.data;
        }, (response) => {
            this.sweetAlert.error(this.locale.getString('seatplans.seatplans.messages.builder_error'), this.locale.getString('seatplans.seatplans.messages.builder_error_message'));
        });
    }

    _prepareDrawInfoFromResponse(dataFromApi) {
        dataFromApi.objects = this._prepareDrawObjectsList(dataFromApi.objects, this.builder.objects);
        return dataFromApi;
    }

    _prepareDrawObjectsList(drawObjectList, originalList) {
        for (let i = 0; i < drawObjectList.length; i++) {
            const currentDrawObject = drawObjectList[i];
            currentDrawObject.original = originalList[i];
            if (currentDrawObject.objects && currentDrawObject.objects.length) {
                currentDrawObject.objects = this._prepareDrawObjectsList(currentDrawObject.objects, originalList[i].objects);
            }

            if (currentDrawObject.bookable) {
                currentDrawObject.status = 'unbooked';
            }

            currentDrawObject.clickable = true;
            currentDrawObject.selectable = false;
        }

        return drawObjectList;
    }

    _createDrawing() {
        if (this.drawing) {
            this.drawing.destruct();
        }
        this.drawing = new FestzeltOSSeatPlanDrawing(this.canvasElement[0],
            this.drawInfo, {
                click: (e, element) => {
                    this.editElement(element.original);
                }
            });
    }

    _resizeCanvas() {
        let newWidth = this.canvasElement.parent().width(),
            newHeight = newWidth * (this.drawInfo.grid_height / this.drawInfo.grid_width);

        this.canvasElement.attr('width', newWidth);
        this.canvasElement.attr('height', newHeight);
    }

    cancel() {
        this.state.go('app.seatplans.details', {id: this.model.seatplan.data.id});
    }

    refreshPreview() {
        console.log(this.builder);
        this.drawInfo = this._prepareDrawInfoFromResponse(_.cloneDeep(this.builder));
        this._resizeCanvas();
        this._createDrawing();
    }

    save(close) {
        this.api.put('seatplans/groups/' + this.model.id + '/builder', this.builder).then((response) => {
            this.builder = response.data;
            if(close) {
                this.cancel();
            } else {
                this.growl.success('Saved successful');
            }
        }, (response) => {
            this.sweetAlert.error(this.locale.getString('seatplans.seatplans.messages.builder_save_error'), this.locale.getString('seatplans.seatplans.messages.builder_save_error_message'));
        });
    }

    editElement(elementToEdit, parentElement) {
        let mainController = this;
        const originalBuilder = _.cloneDeep(this.builder),
            modalInstance = this.modal.open({
                animation: true,
                scope: this.scope,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                templateUrl: 'editElementModal.html',
                controller: [
                    '$scope',
                    'element',
                    'parentElement',
                    function ($scope, element, parentElement) {
                        const modalVm = this;

                        modalVm.element = element;
                        modalVm.original = _.cloneDeep(element);
                        modalVm.labelTypes = [
                            {
                                mainGroup: 'vertical',
                                subGroup: 'left',
                                label: 'Vertical - left'
                            },
                            {
                                mainGroup: 'vertical',
                                subGroup: 'center',
                                label: 'Vertical - center'
                            },
                            {
                                mainGroup: 'vertical',
                                subGroup: 'right',
                                label: 'Vertical - right'
                            },
                            {
                                mainGroup: 'horizontal',
                                subGroup: 'top',
                                label: 'Horizontal - top'
                            },
                            {
                                mainGroup: 'horizontal',
                                subGroup: 'center',
                                label: 'Horizontal - center'
                            },
                            {
                                mainGroup: 'horizontal',
                                subGroup: 'bottom',
                                label: 'Horizontal - bottom'
                            }
                        ];

                        modalVm.ok = () => {
                            modalInstance.close();
                            element = modalVm.element;
                            mainController.refreshPreview();
                        };

                        modalVm.cancel = () => {
                            mainController.builder = originalBuilder;
                            modalInstance.close();
                        };

                    }],
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    element: function () {
                        return elementToEdit;
                    },
                    parentElement: function () {
                        return parentElement;
                    }
                }
            });
    }

    addNewChild(elementToAppend) {
        const newElement = {
            title: 'New element',
            pos: {
                x: 0,
                y: 0
            },
            size: {
                x: 0,
                y: 0
            },
            bookable: false,
            labels: {},
            objects: []
        };
        elementToAppend.objects.push(newElement);
        this.editElement(newElement);
        this.refreshPreview();
    }

    removeElement(parent, elementToRemove) {
        const index = parent.indexOf(elementToRemove);

        if (index > -1) {
            parent.splice(index, 1);
            this.refreshPreview();
        }
    }

    duplicateElement(parent, elementToDuplicate) {
        const newElement = _.cloneDeep(elementToDuplicate);

        if (newElement.id) {
            delete newElement.id;
        }

        newElement.title = newElement.title + ' (copy)';

        parent.push(newElement);
        this.refreshPreview();
    }

    _initDomEvents() {
        angular.element(window).bind('resize', () => {
            this._resizeCanvas();
            if (this.drawing) {
                this.drawing.redraw();
            }
        });

        angular.element(this.canvasElement.parent()).bind('resize', () => {
            this._resizeCanvas();
            if (this.drawing) {
                this.drawing.redraw();
            }
        });

        $(document).on('shown.bs.tab', 'a[data-toggle="tab"]', (e) => {
            this._resizeCanvas();
            if (this.drawing) {
                this.drawing.redraw();
            }
        });
    }

    _updateNavService() {
        this.navService.setStateParameters('app.seatplans.details', {
            id: this.model.seatplan.data.id
        });
        this.navService.setBreadcrumbParameters({
            seatplan_name: this.model.seatplan.data.title,
            group_name: this.model.title
        });
    }
}

SeatplanElementsController.$inject = [
    '$state',
    'SweetAlert',
    'model',
    'Env',
    '$http',
    '$element',
    '$scope',
    '$uibModal',
    'locale',
    'NavService',
    'growl'
];


angular
    .module('festzelt-os.seatplans')
    .controller('SeatplansElementsCtrl', SeatplanElementsController);



// WEBPACK FOOTER //
// ./src/app/pages/seatplans/controllers/seatplans-elements-controller.js